import React from 'react';
import { View } from 'react-native';
import { useSafeAreaInsets } from 'react-native-safe-area-context';
import useStyles from 'hooks/useStyles';
import createStyleSheets from 'utils/createStyleSheets';
import { HELP_ARTICLES_KEY } from 'features/help/constants';
import { useDefaultHeaderHeight } from 'hooks/useHeaderHeight';
import HelpScreenButton from 'features/help/components/HelpScreenButton';
import { rem } from 'design-system';
const FloatingHeaderComp = ({ floating, hideButton, isPotsOnb, leftContent }) => {
    const headerHeight = useDefaultHeaderHeight();
    const styles = useStyles(styleSet);
    const { top } = useSafeAreaInsets();
    return (<View style={floating ? styles.background : null}>
      <View style={[
            {
                height: headerHeight,
                paddingTop: top,
            },
            styles.header,
        ]}>
        <View style={styles.leftContainer}>{leftContent}</View>
        <View style={styles.sideContainer}>
          {!hideButton && <HelpScreenButton articlesKey={isPotsOnb ? HELP_ARTICLES_KEY.POTS_ONBOARDING : undefined}/>}
        </View>
      </View>
    </View>);
};
export default React.memo(FloatingHeaderComp);
const styleSet = createStyleSheets(() => ({
    header: {
        justifyContent: 'center',
        flexDirection: 'row',
        zIndex: 2,
    },
    background: {
        left: 0,
        right: 0,
        zIndex: 1,
        position: 'absolute',
    },
    sideContainer: {
        justifyContent: 'center',
        marginRight: rem(16),
        marginBottom: rem(6),
    },
    leftContainer: {
        flex: 1,
        justifyContent: 'center',
    },
}));
